module.exports = __webpack_public_path__ + "static/hackathon-4-94c33982db096f4ffb66d3ddd39a9433.jpg";